import { render, staticRenderFns } from "./MatrioshkaVisualizationColumn.vue?vue&type=template&id=38cf4e10&scoped=true"
import script from "./MatrioshkaVisualizationColumn.vue?vue&type=script&lang=js"
export * from "./MatrioshkaVisualizationColumn.vue?vue&type=script&lang=js"
import style0 from "./MatrioshkaVisualizationColumn.vue?vue&type=style&index=0&id=38cf4e10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cf4e10",
  null
  
)

export default component.exports